import { render, staticRenderFns } from "./ManageVendor.vue?vue&type=template&id=31575a2f&"
import script from "./ManageVendor.vue?vue&type=script&lang=js&"
export * from "./ManageVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports